module.exports = __webpack_public_path__ + "42b6fe5640909f3dba9bd3506d4efb45.svg";